// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Dialog_dialog__1SeQq","title":"Dialog_title__1FDzp","content":"Dialog_content__hXqtb","buttonsRight":"Dialog_buttonsRight__26nKP","buttons":"Dialog_buttons__2uLeD"};